export const LawsuitStatusEnum = {
    CREATED: 1,
    WAITING_DOCUMENT: 2,
    WAITING_VALIDATION: 3,
    CONCLUDED: 4,
};
